<template>
  <div>
    <!-- OLD DIV VERSION    <div class="col-md-10 col-sm-9 col-md-offset-2 col-sm-offset-3 content container-fluid">-->
    <div class="col-xs-12 content container-fluid">
      <div class="wrapper">
        <div class="container-wrapper">
          <div id="alerts-container"></div>
        </div>
      </div>
      <div id="app" class="ui vertical stripe segment">
        <div class="row">
          <div class="col-xs-12 m-t-20">
            <div class="table-responsive">
              <div id="content" class="ui basic segment">
                <table
                  id="table-with-sorting"
                  class="table data-table with-sorting table-striped tablesorter payment-batch-table sortable"
                >
                  <thead>
                    <tr>
                      <th style="width: 40px;"></th>
                      <th>Id</th>
                      <th>Usuario</th>
                      <th>Oferta</th>
                      <th>Comentario</th>
                      <th>Puntaje</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody v-if="!loadingTable">
                    <tr v-for="comment in commets">
                      <td>
                        <input :value="comment" v-model="checkedComment" type="checkbox" />
                      </td>
                      <td>{{ comment.id }}</td>
                      <td>{{ comment.fullname }}</td>
                      <td>{{ comment.offers.title }}</td>
                      <td>{{ comment.content }}</td>
                      <td>{{ comment.starts }} de 5</td>
                      <td>
                        <a @click="changesStatus(comment,1);" class="btn btn-success btn-xs">Aprobar</a>
                        <a @click="changesStatus(comment,2);" class="btn btn-danger btn-xs">Cancelar</a>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot v-show="!loadingTable">
                    <tr>
                      <th colspan="12">
                        <div class="row">
                          <div class="col-xs-12">
                            <pagination
                              :total="total"
                              :page-size="pageSize"
                              :callback="pageChanged"
                              :options="paginationOptions"
                              nav-class="padding-10"
                              ul-class="bg-color-red"
                              li-class="txt-color-blue"
                            ></pagination>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </tfoot>
                </table>
                <template v-if="loadingTable">
                  <div style="text-align:center">
                    <span class="fa fa-spin fa-spinner"></span>
                  </div>
                </template>
              </div>
            </div>
            <!--</div>-->
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER   -->
    <footer class="footer b-t b-grey">
      <div class="copyright">2016 &copy; Cash Depot - Todos los derechos reservados.</div>
    </footer>
  </div>
</template>

<script>
import Pagination from "../utilities/pagination.vue";
export default {
  data() {
    return {
      api_url: `http://api.cashdepotint.com/v1`,
      currentPage: 1,
      checkedComment: [],
      validity: "",
      amount: 0,
      cost: 0,
      columnTitles: {
        id: "Id",
        title: "Usuario",
        description: "Ofertas",
        content: "Comentario",
      },
      loadingTable: true,
      total: 1000,
      pageSize: 50,
      paginationOptions: {
        // Not required to pass this configurations
        offset: 1,
        previousText: "Anterior",
        nextText: "Siguiente",
        alwaysShowPrevNext: true,
      },
      commets: [],
      sortBy: "id",
      sortOrder: "DESC",
      moreParams: ["q=(is_deleted:0)"],
      visibleColumns: [],
      vid: false,
      selectedColumns: "",
      user_id: "",
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.user_id = this.$route.query.id;

    if (!this.user_id) {
      this.user_id = window.localStorage.getItem("user_id");
    } else {
      window.localStorage.setItem("user_id", this.user_id);
    }

    this.getComments();
  },
  methods: {
    sync: function (event, tipo) {
      event.preventDefault();
      this[tipo] = event.target.files[0] || event.dataTransfer.files[0];

      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (event) => {
        vm.imageSrc = event.target.result;
      };

      reader.readAsDataURL(this[tipo]);
    },
    getComments: function () {
      this.$http
        .get(
          apiUrl +
            `/comments?relationships=offers&q=(status_id:0)&format=true&page=${this.currentPage}&sort=${this.sortBy}|${this.sortOrder}`
        )
        .then(
          (response) => {
            this.commets = response.body.data;
            this.total = response.body.total_pages * 50;
            this.loadingTable = false;
          },
          (response) => {
            sweetAlert(
              "Oops...",
              "Ha ocurrido un error al cargar los proovedores !",
              "error"
            );
          }
        );
    },
    pageChanged(page) {
      this.currentPage = page;
      this.getProviders();
      // Exec your response to server passing 'page' params as clicked button paging
    },
    getUserName(UserId) {
      return "Unok " + UserId;
    },
    changesStatus(comment, status) {
      var text = status == 1 ? "Aprobar" : "Eliminar";
        this.loadingTable = true;

        this.$http({
          emulateJSON: true,
          emulateHTTP: true,
          url: apiUrl + `/comments/` + comment.id + `/status`,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: { status: status },
        }).then(
          function (response) {
            sweetAlert("Todo correcto", "Comentario " + text, "success");
            this.getComments();
            this.loadingTable = false;
          },
          (response) => {
            sweetAlert("Oops...", "Ha ocurrido un error !", "error");
            this.loadingTable = false;
          }
        );
    },
  },

  events: {
    "vuetable:action": function (action, data) {
      if (action == "view-item") {
        window.location.href = "/#!/offers/" + data.id + "/information";
      }
    },
    "vuetable:load-error": function (response) {
      console.log("Load Error: ", response);
    },
    "vuetable:loaded": function (response) {
      this.loadingTable = false;
    },
    "reload-table"() {
      this.getProviders();
    },
    "updated-offer"() {
      this.getProviders();
    },
  },
};
</script>

<style scoped>
.txt-blue {
  color: #0000ee;
}
</style>



// WEBPACK FOOTER //
// comments.vue?7ec7d408